module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado5.e4a44740.svg";